import { Location } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-back',
    templateUrl: './back.component.html',
    styleUrls: [ './back.component.scss' ]
})
export class BackComponent implements OnInit
{
    @Input('close') close = false;
    @Input() private url: string;
    @Input() private locationBack = false;

    @Output() onBack: EventEmitter<void> = new EventEmitter();

    constructor(
        private router: Router,
        private location: Location
    ) { }

    ngOnInit(): void
    {
    }

    public back(): Promise<boolean> | void
    {
        if (Boolean(this.url)) { return this.router.navigateByUrl(this.url); }

        if (this.locationBack) {  return this.location.back(); }

        this.onBack.emit();
    }

}
